import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, CardContent, Typography, IconButton, Box, Tooltip } from '@mui/material';
import { DragIndicator as DragIcon, Send as SendIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { format } from 'date-fns';

/**
 * Sortable queue item component with drag handle
 */
const SortableQueueItem = ({ question, index, onSendNow, onRemove }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: question.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  const publishDate = question.publishDate?.toDate 
    ? question.publishDate.toDate() 
    : new Date(question.publishDate);

  return (
    <Card
      ref={setNodeRef}
      style={style}
      sx={{
        mb: 2,
        cursor: isDragging ? 'grabbing' : 'grab',
        '&:hover': {
          boxShadow: 3,
        },
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="flex-start" gap={2}>
          {/* Drag Handle */}
          <Box {...attributes} {...listeners} sx={{ cursor: 'grab', pt: 0.5 }}>
            <DragIcon color="action" />
          </Box>

          {/* Content */}
          <Box flex={1}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Typography variant="h6" component="span" fontWeight={600}>
                {index + 1}.
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sends {format(publishDate, 'EEE, MMM d @ h:mm a')}
              </Typography>
            </Box>

            <Typography variant="body1" sx={{ mb: 1 }}>
              {question.questionText}
            </Typography>

            {question.suggestedByName && (
              <Typography variant="caption" color="text.secondary">
                💬 Suggested by: {question.suggestedByName}
              </Typography>
            )}
          </Box>

          {/* Actions */}
          <Box display="flex" gap={1}>
            <Tooltip title="Send Now">
              <IconButton
                size="small"
                color="primary"
                onClick={() => onSendNow(question.id)}
              >
                <SendIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Remove from Queue">
              <IconButton
                size="small"
                color="error"
                onClick={() => onRemove(question.id)}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SortableQueueItem;
